import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import App from '../App';
import GuestPage from '../GuestPage';
import AddGuestForm from './AddGuest';
import Pictures from '../Pictures';
import GuestQuestions from '../GuestQuestions';
import GuestList from './GuestList';
import AdminPanel from './AdminPanel';
import StartThis from '../StartThis';
import GuestName from '../GuestName';
import Home from '../Home';
import Menu from '../Menu';
import Scorecard from '../Scorecard';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/show" element={<App />} />

        <Route path="/pictures" element={<Pictures />} />
        <Route path="/start" element={<StartThis />} />

        <Route path="/menu" element={<Menu />} />

        <Route path="/score" element={<Scorecard />} />

        <Route path="/admin-guest-list" element={<GuestList  />} />
        <Route path="/admin-guest-edit/:documentId" element={<AddGuestForm  mode="edit" />} />
        <Route path="/admin-add-guest" element={<AddGuestForm mode="add" />} />
        <Route path="/admin-panel" element={<AdminPanel mode="add" />} />

        <Route path="/guest-questions/:documentId" element={<GuestQuestions />} />
        <Route path="/guest-access/:documentId" element={<GuestPage mode="edit" />} />
        <Route path="/guest-name/:documentId" element={<GuestName mode="edit" />} />


      </Routes>
    </Router>
  );
};

export default AppRouter;
